import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'
import {checkPermission, CAN_CREATE_PROJECT_DISCIPLINES, CAN_EDIT_PROJECT_DISCIPLINES} from "../../../lib/permissions";

const create = {
    table: 'project_disciplines',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Project Discipline',
        type: 'object',
        required: ['description'],
        properties: {
            description: {type: 'string', title: 'Description'}
        }
    }
}

const update = {
    table: 'project_disciplines',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Project Discipline',
        type: 'object',
        required: ['description'],
        properties: {
            project_discipline_id: {type: 'integer'},
            description: {type: 'string', title: 'Description'}
        }
    },
    uiSchema: {
        project_discipline_id: {"ui:widget": "hidden"},
    },
}

const read = {
    title: 'Project Disciplines',
    description: 'Project Disciplines define the roles required for a project.',
    table: 'project_disciplines',
    fields: ['project_discipline_id', 'description'],
    uniqueKey: 'project_discipline_id',
    columns: [
        {Header: 'ID', accessor: 'project_discipline_id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'}
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class ProjectDisciplines extends Component{

    render(){
        return (
            <CRUDManager
                canCreate={checkPermission(CAN_CREATE_PROJECT_DISCIPLINES)}
                canEdit={checkPermission(CAN_EDIT_PROJECT_DISCIPLINES)}
            />
        )
    }
}

export default ProjectDisciplines